import "./styles.scss";

export const CSpinner = ({ size = 50, color = "#ffa516" } = {}) => {
  return (
    <div
      className="c-spinner"
      style={{
        "--spinner-size": `${size}px`,
        "--spinner-color": color,
      }}
    ></div>
  );
};
